import { Component } from 'react'
import PropTypes from 'prop-types'

import { compose } from 'recompose'
import keydown, { Keys } from 'react-keydown'

const { LEFT, RIGHT } = Keys

class KeyboardNavigation extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    handleKeyDown: PropTypes.func.isRequired,
  }

  componentWillReceiveProps({ keydown }) {
    if (keydown) {
      if (keydown.event) {
        this.props.handleKeyDown(keydown.event.keyCode)
      }
    }
  }

  render() {
    return this.props.children
  }
}

const composed = compose(keydown(LEFT, RIGHT))

export default composed(KeyboardNavigation)
